module.exports = __webpack_public_path__ + "img/icon_6.a9bce4bc.png";